module.exports = __webpack_public_path__ + "img/logo_icon.95435b92.png";